import React from "react";
import { cn } from "./../../../Utils/helper/index";

export function FormField({
  icon,
  placeholder,
  rightIcon,
  value,
  onChange,
  name,
  type = "text",
  className,
  classNameImageLeft,
  classNameImageRight,
  classNameInput,
  numeric = false,
  label,
  maxLength,
  typeInput = "input",
  ...props
}) {
  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    if (numeric) {
      inputValue = inputValue.replace(/[^0-9]/g, "");
    }

    if (maxLength && inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }

    if (onChange) {
      e.target.value = inputValue;
      onChange(e);
    }
  };

  return (
    <>
      <div className="mt-6">
        {label && (
          <label className="flex items-center self-start leading-none text-neutral-500">
            <span className="self-stretch my-auto">{label}</span>
          </label>
        )}
        <div
          className={cn(
            "flex gap-1.5 items-start px-1.5 py-2.5  w-full bg-white rounded-xl border border-solid border-stone-200 min-h-[42px]",
            className
          )}
        >
          {icon && (
            <img
              loading="lazy"
              src={icon}
              alt=""
              className={cn("object-contain shrink-0  w-5", classNameImageLeft)}
            />
          )}

          {typeInput === "input" ? (
            <input
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={handleInputChange}
              name={name}
              className={cn(
                "flex-1 bg-transparent border-none outline-none",
                classNameInput
              )}
              maxLength={maxLength}
              {...props}
            />
          ) : (
            <textarea
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={handleInputChange}
              name={name}
              className={cn(
                "flex-1 bg-transparent border-none outline-none min-h-[200px]",
                classNameInput
              )}
              maxLength={maxLength}
              {...props}
            />
          )}

          {rightIcon && (
            <img
              loading="lazy"
              src={rightIcon}
              alt=""
              className={cn(
                "object-contain shrink-0 self-stretch my-auto w-5",
                classNameImageRight
              )}
            />
          )}
        </div>
      </div>
    </>
  );
}
